import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import zh from "../locales/zh.json";
const resources = {
    en: { translation: en },
    zh: { translation: zh },
};
// Detect browser language, falling back to 'en'
const detectedLng = typeof navigator !== "undefined"
    ? navigator.language.split("-")[0]
    : "en";
i18n.use(initReactI18next).init({
    resources,
    lng: detectedLng,
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
